import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ILabelRow } from '../labels.service';

interface iSelectLabelRow extends ILabelRow {
  selected?: boolean;
}

@Component({
  selector: 'app-labels-table',
  templateUrl: './labels-table.component.html',
  styleUrls: ['./labels-table.component.scss']
})
export class LabelsTableComponent implements OnInit {

  @Output() onSelectionChange = new EventEmitter<iSelectLabelRow[]>();

  sort: MatSort;
  @ViewChild(MatSort, { static: false }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDatasourceData();
  }

  numberOfLabels: number = 0;
  isAllSelected: boolean;
  saveButtonIsEnabled: boolean;

  displayedColumns: string[] = [
    'labelIsCreated',
    'orderNr',
    'datumAangemaakt',
    'debiteurNrs',
    'leverDatumTijdstip',
    'leverTijdstip',
    'kwekerArtikelNr',
    'klantArtikelOmschrijving',
    'potmaat',
    'barCode',
    'stickerBelading'
  ];

  @Input() onlyShowPrintedRegels: boolean;
  _data: iSelectLabelRow[];

  @Input()
  public get data() {
    return this._data;
  }
  public set data(value: iSelectLabelRow[]) {
    this._data = value;
    this.setDatasourceData();
  }

  dataSource: MatTableDataSource<ILabelRow> = new MatTableDataSource<ILabelRow>();

  ngOnInit() {
    this.setDatasourceData();
  }

  setDatasourceData() {
    this.dataSource.sort = this.sort;
    if (this._data) {
      this.dataSource.data = this._data;
      this.isAllSelected = this._data.every(row => row.selected);
    }
  }

  toggleSelected(item: iSelectLabelRow): void {

    this.isAllSelected = this._data.every(row => row.selected);
    this.onSelectionChange.emit(this.data.filter(item => item.selected));
  }

  markAll() {
    var printed = this.isAllSelected;
    this.data.forEach(function (item) {
      item.selected = printed;
    });

    this.onSelectionChange.emit(this.data.filter(item => item.selected));
  }

  trackById(index, item) {
    return item.id; //index;
  }
}
